mutation updatePersonManager($personId: ID!, $managerId: ID!) {
  person: updatePersonManager(personId: $personId, managerId: $managerId) {
    aggregateId
    managedBy {
      aggregateId
    }
  }
}
